import type { OnboardingState, ReportSummary } from '@tallyframe/core';

/** Step 1, "Make your first report": any report has an active snapshot. */
export const hasData = (reports: ReportSummary[]): boolean => reports.some((r) => r.dataAsOf !== null);

/** Steps 1 and 2 ("Share it": a report.published event exists) are both done. */
export const stepsDone = (reports: ReportSummary[], onboarding: OnboardingState): boolean =>
  hasData(reports) && onboarding.shared;

export type ChecklistView = 'checklist' | 'set' | 'none';

export function checklistView(input: {
  stepsDone: boolean;
  agentCardOpen: boolean;
  dismissed: boolean;
  reopened: boolean;
}): ChecklistView {
  if (input.dismissed) return 'none';
  if (!input.stepsDone) return 'checklist';
  if (input.reopened || input.agentCardOpen) return 'set';
  return 'none';
}

/** The report with data whose updatedAt is latest; ties go to the highest id. */
export function shareTarget(reports: ReportSummary[]): ReportSummary | undefined {
  let best: ReportSummary | undefined;
  for (const r of reports) {
    if (r.dataAsOf === null) continue;
    if (
      !best ||
      r.updatedAt > best.updatedAt ||
      (r.updatedAt === best.updatedAt && r.id > best.id)
    ) {
      best = r;
    }
  }
  return best;
}
